import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossUsers } from '../components/views/militaryHearingLossView/MilitaryHearingLossUsers/MilitaryHearingLossUsers'

function MilitaryHearingLossUsersPage() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Agents" />
                    <MilitaryHearingLossUsers />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossUsersPage
